export const PAGE_SIZE = 10
export const GET_ALL_USER_SIZE = 1000000
export const MODE = {
  EDIT: 'edit',
  CREATE: 'create',
}
const QUERY_KEY_TYPE = {
  LIST: 'list',
  DETAIL: 'detail',
}

function createQueryKeys(baseName) {
  return {
    all: [baseName],
    list: (filters) => [baseName, QUERY_KEY_TYPE.LIST, filters],
    detail: (id) => [baseName, QUERY_KEY_TYPE.DETAIL, id],
  }
}

export const accountKeys = createQueryKeys('account')
export const guestKeys = createQueryKeys('guest')
export const bookKeys = createQueryKeys('books')
export const errorKeys = createQueryKeys('errors')
export const adminKeys = createQueryKeys('admins')
export const bookPackageKeys = createQueryKeys('bookPackages')
export const accountGroupKeys = createQueryKeys('accountGroups')
export const bookBorrowKeys = createQueryKeys('bookBorrow')
export const accountsBorrowKeys = createQueryKeys('accountsBorrow')
